import React, { useState }  from 'react';
import SectionHeading from '../../Common/SectionHeading';
import Image from 'next/image';


const TrackingProcess = ({title=null}) => {
  
  return (
    <section className="our-services rotated-bg">
      <div className="w-11/12 xl:max-w-screen max-w-screen-2xl flex flex-col justify-center mx-auto lg:py-8 py-4">
        {(title) &&
            <SectionHeading title={title} customClass='text-center'/>
        }
        <div className="grid grid-cols-12 gap-4">
          <div className="lg:col-span-4 md:col-span-6 col-span-12">
            <div className="single-service-item">
              <div className="service-left-bg"></div>
              <div className="service-icon">
                <div className="icon-wrapper">
                  <Image 
                    priority={false} 
                    src={process.env.IMG_CDN+'img/consulting/jpg/ci-tracking/background-search.svg'}
                    alt="Background Search" 
                    className="mx-auto" 
                    width={2000} 
                    height={2000} 
                  />
                </div>
              </div>
              <div className="service-text">
                <h4 className="text-xl font-semibold">Background Search</h4>
                <p className="delve-p fs-16">Creating a background for tracking is essential in developing a robust process for exhaustive coverage.</p>
              </div>
            </div>
          </div>
          <div className="lg:col-span-4 md:col-span-6 col-span-12">
            <div className="single-service-item">
              <div className="service-left-bg"></div>
              <div className="service-icon">
                <div className="icon-wrapper">
                  <Image 
                    priority={false} 
                    src={process.env.IMG_CDN+'img/consulting/jpg/ci-tracking/finalize-the-list-of-Keywords.svg'}
                    alt="Background Search" 
                    className="mx-auto" 
                    width={2000} 
                    height={2000} 
                  />
                </div>
              </div>
              <div className="service-text">
                <h4 className="text-xl font-semibold">Finalize the List of Keywords</h4>
                <p className="delve-p fs-16">Keywords are essential to competitive intelligence tracking to gain minute details for each research aspect.</p>
              </div>
            </div>
          </div>
          <div className="lg:col-span-4 md:col-span-6 col-span-12">
            <div className="single-service-item">
              <div className="service-left-bg"></div>
              <div className="service-icon">
                <div className="icon-wrapper">
                  <Image 
                    priority={false} 
                    src={process.env.IMG_CDN+'img/consulting/jpg/ci-tracking/conduct-exhaustive-research.svg'}
                    alt="Background Search" 
                    className="mx-auto" 
                    width={2000} 
                    height={2000} 
                  />
                </div>
              </div>
              <div className="service-text">
                <h4 className="text-xl font-semibold">Conduct Exhaustive Research</h4>
                <p className="delve-p fs-16">Continuous tracking of parameters and updates of milestones via DelveInsight’s proprietary methodology</p>
              </div>
            </div>
          </div>
          <div className="lg:col-span-4 md:col-span-6 col-span-12">
            <div className="single-service-item">
              <div className="service-left-bg"></div>
              <div className="service-icon">
                <div className="icon-wrapper">
                  <Image 
                    priority={false} 
                    src={process.env.IMG_CDN+'img/consulting/jpg/ci-tracking/collate-and-analyze-information.svg'}
                    alt="Background Search" 
                    className="mx-auto" 
                    width={2000} 
                    height={2000} 
                  />
                </div>
              </div>
              <div className="service-text">
                <h4 className="text-xl font-semibold">Collate and Analyze Information</h4>
                <p className="delve-p fs-16">Collected information is passed through various filters to extract the most relevant insights, as required by DelveInsight’s client partners</p>
              </div>
            </div>
          </div>
          <div className="lg:col-span-4 md:col-span-6 col-span-12">
            <div className="single-service-item">
              <div className="service-left-bg"></div>
              <div className="service-icon">
                <div className="icon-wrapper">
                  <Image 
                    priority={false} 
                    src={process.env.IMG_CDN+'img/consulting/jpg/ci-tracking/develop-initial-reports.svg'}
                    alt="Background Search" 
                    className="mx-auto" 
                    width={2000} 
                    height={2000} 
                  />
                </div>
              </div>
              <div className="service-text">
                <h4 className="text-xl font-semibold">Develop Initial Reports</h4>
                <p className="delve-p fs-16">Flexible reporting options, catering to a wide variety of output formats depending on clients needs, as well as the objective of the research</p>
              </div>
            </div>
          </div>
          <div className="lg:col-span-4 md:col-span-6 col-span-12">
            <div className="single-service-item">
              <div className="service-left-bg"></div>
              <div className="service-icon">
                <div className="icon-wrapper">
                  <Image 
                    priority={false} 
                    src={process.env.IMG_CDN+'img/consulting/jpg/ci-tracking/monitor-and-update-results.svg'}
                    alt="Background Search" 
                    className="mx-auto" 
                    width={2000} 
                    height={2000} 
                  />
                </div>
              </div>
              <div className="service-text">
                <h4 className="text-xl font-semibold">Monitor and Update Results</h4>
                <p className="delve-p fs-16">CI tracking&apos;s beauty lies in monitoring and promptly updating on breakthroughs, keeping clients abreast of evolving market dynamics.</p>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default TrackingProcess;